var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    style: {
      borderRadius: 7
    },
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6921 0H2.30787C1.03319 0 0 1.03319 0 2.30787V29.6921C0 30.9668 1.03319 32 2.30787 32H29.6921C30.9668 32 32 30.9668 32 29.6921V2.30787C32 1.03319 30.9668 0 29.6921 0V0ZM24.0154 12.2474V14.4108C22.9953 14.4111 22.0041 14.2113 21.0694 13.8168C20.4683 13.5631 19.9083 13.2361 19.3961 12.841L19.4115 19.4999C19.4051 20.9993 18.8119 22.4081 17.7383 23.4692C16.8645 24.333 15.7573 24.8823 14.5573 25.0601C14.2753 25.1018 13.9884 25.1232 13.6982 25.1232C12.4136 25.1232 11.194 24.7071 10.1964 23.9393C10.0086 23.7948 9.82912 23.6381 9.65812 23.4692C8.49456 22.3193 7.89456 20.7605 7.99556 19.1208C8.07269 17.8726 8.57238 16.6823 9.40544 15.7493C10.5076 14.5146 12.0496 13.8293 13.6982 13.8293C13.9884 13.8293 14.2753 13.8511 14.5573 13.8929V14.6927V16.9178C14.29 16.8296 14.0044 16.7811 13.7071 16.7811C12.2009 16.7811 10.9823 18.01 11.0048 19.5173C11.0191 20.4818 11.5459 21.3248 12.3229 21.7895C12.6881 22.0079 13.1082 22.1432 13.5565 22.1678C13.9078 22.1871 14.245 22.1382 14.5573 22.0351C15.6334 21.6796 16.4097 20.6688 16.4097 19.4766L16.4133 15.0175V6.87675H19.3926C19.3954 7.17194 19.4254 7.46 19.4811 7.73906C19.7059 8.86875 20.3427 9.84888 21.2289 10.5171C22.0017 11.0999 22.9639 11.4454 24.0069 11.4454C24.0076 11.4454 24.0162 11.4454 24.0155 11.4447V12.2474H24.0154Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokSocial);
export default __webpack_public_path__ + "static/media/tiktok-social.90d7d66b19d0a420843c1735bd13f467.svg";
export { ForwardRef as ReactComponent };